<template>
  <div>
    <el-col :span="12">
      <div class="search">
        <el-col :span="20">
        <el-input v-model="formData.keyword" placeholder="请输入内容"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="searchDemands()">搜索</el-button>
      </el-col>
      </div>
      
    </el-col>
    <el-table :data="tableData" style="width: 100%" height="250" border>
      <el-table-column fixed prop="user_name" label="用户名" width="90" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="name" label="需求标题" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="unit_num" label="需求数量" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="freight" label="交货方式" width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="demands" label="需求内容" width="300" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="drawing" label="图纸" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
        <el-image 
    style="width: 30px; height: 30px"
    :src="scope.row.drawing[0]" 
    :preview-src-list="scope.row.drawing">
  </el-image>
      </template></el-table-column>
      <el-table-column prop="click_num" label="被查看次数" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="province" label="省" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="city" label="市" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="area" label="区" width="120" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="formData.page"
      :page-sizes="[20,60,100,140]"
      :page-size="formData.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "DemandManage",
  data() {
    return {
      formData: {
        keyword: "",
        startDate: "",
        endDate: "",
        page: 1,
        limit: 20
      },
      count: 0,
      tableData: [],
      url:require("@/assets/images/BOM-img.png")
    };
  },
  methods: {
    searchDemands() {
      let formData = this.formData;
      this.$http
        .post("/v2/validate/SearchMyDemand", { formData })
        .then(res => {
          console.log(res.data);
          this.tableData = res.data;
         
          
          this.count = res.count;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSizeChange(val) {
      this.formData.limit = val;
      this.searchDemands();
    },
    handleCurrentChange(val) {
      this.formData.page = val;
      this.searchDemands();
    }
  },
  created() {
    this.searchDemands();
  }
};
</script>

<style scoped>
.pagination{text-align: center;margin-bottom: 25px;}
.search{text-align: center }
.search .el-col {margin-bottom: 15px}
</style>